import { FilterState } from "./filter-section"

export const filtersToUrlParams = (filters: FilterState, sortBy: string
): URLSearchParams => {
  const params = new URLSearchParams()

  // Add filter parameters
  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length > 0) {
      // Handle array values (like brands, processors, etc.)
      value.forEach((item) => {
        params.append(key.toLowerCase(), item)
      })
    } else if (
      typeof value === "object" &&
      value !== null &&
      "min" in value &&
      "max" in value
    ) {
      // Handle price range
      params.set("minPrice", value.min.toString())
      params.set("maxPrice", value.max.toString())
    }
   
  })
  params.set("sort", sortBy)
  return params
}

// export const urlParamsToFilters = (
//   params: URLSearchParams
// ): { filters: FilterState; sortBy: string } => {
//   const filters: FilterState = {}

//   // Get filter parameters
//   const filterKeys = ["brand", "processor", "ram", "storage", "categories"]

//   filterKeys.forEach((key) => {
//     const values = params.getAll(key)
//     console.log(values, "values")
//     if (values.length > 0) {
//       // Convert to title case for the filter state
//       const titleCaseKey = key.charAt(0).toUpperCase() + key.slice(1)
//       filters[titleCaseKey] = values
//     }
//   })

//   console.log(filters)

//   // Handle price range
//   const minPrice = params.get("minPrice")
//   const maxPrice = params.get("maxPrice")
//   if (minPrice && maxPrice) {
//     filters.Price = {
//       min: Number.parseInt(minPrice),
//       max: Number.parseInt(maxPrice),
//     }
//   }

//   const sortBy = params.get("sort") || "relevance"

//   return { filters, sortBy }
// }
export const urlParamsToFilters = (
  params: URLSearchParams
): { filters: FilterState; sortBy: string } => {
  const filters: FilterState = {}

  // Define exactly the mapping from URL key → FilterState property
  const keyMap: Record<string, keyof FilterState> = {
    brand: "Brand",
    processor: "Processor",
    ram: "RAM",
    storage: "Storage",
    categories: "Categories",
  }

  Object.entries(keyMap).forEach(([urlKey, stateKey]) => {
    const values = params.getAll(urlKey)
    if (values.length > 0) {
      filters[stateKey] = values
    }
  })

  // Handle price range
  const minPrice = params.get("minPrice")
  const maxPrice = params.get("maxPrice")
  if (minPrice && maxPrice) {
    filters.Price = {
      min: Number(minPrice),
      max: Number(maxPrice),
    }
  }

  const sortBy = params.get("sort") || "relevance"

  return { filters, sortBy }
}

export const getSortValue = (sort: string): string => {
  switch (sort) {
    case "low":
      return "payable:ASC"
    case "high":
      return "payable:DESC"
    case "recent":
      return "createdAt:DESC"
    case "relevance":
      return "relevance_device:DESC"
    default:
      return "relevance_device:DESC"
  }
}

export const sortingOptions = [
  { label: "Relevance", value: "relevance" },
  { label: "Most Recent", value: "recent" },
  { label: "Highest Price", value: "high" },
  { label: "Lowest Price", value: "low" },
]
